import * as fs from "fs";
import * as ko from "knockout";
import * as moment from "moment";
import { RNSAPI } from "../../api";
import { MainViewModel } from "../../main";
import '../zpe/mail';
import '../dataTable/dataTable';
import '../empty/empty';

enum ZPECategories {
    Emails = "Emails",
    ScanPool = "ScanPool",
    EConsult = "EConsult",
    Debris = "Debris"
}

export class Interval {
    public readonly startDate: moment.Moment
    public readonly endDate: moment.Moment

    constructor(startDate: moment.Moment, endDate: moment.Moment) {
        this.startDate = startDate;
        this.endDate = endDate;
    }
}

export class ZPEViewModel {
    currentViewer = ko.observable("empty-view");
    currentViewerParams = ko.observable({});

    intervalLength = ko.observable(30);
    interval = ko.pureComputed(() => {
        let length = this.intervalLength();
        let endDate = moment.utc().endOf("day");
        let startDate = endDate.clone().subtract(length, "days").startOf("day");
        return new Interval(startDate, endDate);
    })
    currentCategory = ko.observable(ZPECategories.Emails);
    //export for knockout to see
    categories = ZPECategories;

    selectedObject = ko.observable(null);

    mails = ko.observableArray([]);
    scanPool = ko.observableArray([]);

    caseId = ko.observable("");
    clerkId = ko.observable("");

    modalTitle = ko.observable("");
    modalKeys = ko.observableArray([]);
    modalColumns = ko.observableArray([]);
    modalData = ko.observableArray([]);
    modalHandleSelection: KnockoutObservable<(selectedObject: any) => void> = ko.observable();

    async pickGeneric(title, keys, columns, data) {
        this.modalTitle(title);
        this.modalKeys(keys);
        this.modalColumns(columns);
        this.modalData(data);
    };

    pickCase = async () => {
        let cases = (await RNSAPI.getCases()).Payload.Cases;
        this.pickGeneric("Akte", ["Registernummer", "Rubrum", "Wegen"], ["Registernummer", "Rubrum", "Wegen"], cases);
        this.modalHandleSelection((selectedObject) => this.caseId(selectedObject()["Registernummer"]));
        $('#modal').modal('show');
    };

    pickClerk = async () => {
        let clerks = (await RNSAPI.getSachbearbeiter()).Payload.Clerks.filter(clerk => clerk.Sachbearbeiter_ID !== "");
        this.pickGeneric("Sachbearbeiter", ["Sachbearbeiter"], ["Sachbearbeiter"], clerks);
        this.modalHandleSelection((selectedObject) => this.clerkId(selectedObject()["Sachbearbeiter_ID"]));
        $('#modal').modal('show');
    };

    async loadMailData() {
        this.mails(((await RNSAPI.getMailsByDateInterval(this.interval().startDate, this.interval().endDate)).Payload.Emails)
            .sort((m1, m2) => {
                let d1 = new Date(m1.EMailDate);
                let d2 = new Date(m2.EMailDate);
                if (d1 < d2) {
                    return 1;
                } else {
                    return -1;
                }
            })
            .map(mail => {
                mail.EMailDate = (new Date(mail.EMailDate)).toLocaleDateString();
                mail.actionHandlers = [
                    {
                        icon: "eye", selectable: true, name: "eye", action: async () => {
                            this.selectedObject(mail);
                            this.showEmail(mail.EMailAccountID, mail.RNSMail_ID);
                        }
                    },
                    {
                        icon: "trash-alt", selectable: true, name: "trash-alt", action: async () => {
                            this.selectedObject(mail);
                            this.deleteMail(mail.EMailAccountID, mail.RNSMail_ID);
                        }
                    }
                ];
                return mail;
            }));
    }

    uploadToScanPool = (vm, evt) => {
        let files = evt.target.files;
        let count = files.length;
        let errors: Array<string> = [];

        //FATS limits us to 30 characters max
        let illegal = (Array.from(files) as Array<any>).filter(f => f.name.length > 30).map(f => f.name);

        if (illegal.length > 0) {
            alert(`Die Dateinamen der folgenden folgenden Dateien ist zu lang: [${illegal.join()}]`);
            return;
        }

        for (let file of files) {
            let reader = new FileReader();
            reader.onload = ((f) => {
                return async (e) => {
                    let fileName = f.name;
                    let base64Content = e.target.result.split(',')[1];

                    let apiResult = await RNSAPI.uploadToScanPool(fileName, base64Content);
                    if (apiResult.Type !== "UploadSuccessful") {
                        errors.push(f.name);
                    }
                    count--;
                    //JS is single threaded so there is no race condintion here
                    if (count === 0 && errors.length !== 0) {
                        alert(`Die Dateien ${errors.join()} konnten nicht erfolgreich hochlgeladen werden.`);
                        this.loadScanPool();
                    } else if (count === 0) {
                        alert("Alle Dateien konnten erfolgreich hochgeladen werden.");
                        this.loadScanPool();
                    }
                };
            })(file);

            reader.readAsDataURL(file);
        }

    }

    async loadScanPool() {
        this.scanPool((await RNSAPI.getScanPoolByDateInterval(this.interval().startDate, this.interval().endDate)).Payload.ScannedFiles
            .sort((a, b) => {
                let dateA = new Date(a.UploadDate);
                let dateB = new Date(b.UploadDate);
                if (dateA < dateB) return 1;
                else if (dateA > dateB) return -1;
                else return 0;
            })
            .map(file => {
                file.UploadDate = (new Date(file.UploadDate)).toLocaleDateString();
                file.actionHandlers = [{
                    icon: "eye", selectable: true, name: "eye", action: async () => {
                        this.selectedObject(file.Name);
                        this.showScanPoolEntry(file.Name);
                    }
                }];

                return file;
            }));
    }

    loadZPEData() {
        this.loadMailData();
        this.loadScanPool();
    }

    async associateEmailWithCase(mail: any) {
        let result = await RNSAPI.moveMailToCase(mail.EMailAccountID, mail.RNSMail_ID, this.caseId(), this.clerkId());
        if (result.Type === "Successful") {
            this.loadMailData();
        } else {
            alert("Fehler beim Zuordnen.");
        }
    }

    async associateScanPoolWithCase(fileName: string) {
        let result = await RNSAPI.moveScanToCase(fileName, this.caseId(), this.clerkId());
        if (result.Type === "Successful") {
            this.loadScanPool();
        } else {
            alert("Fehler beim Zuordnen.");
        }
    }

    associateWithCase = async () => {
        switch (this.currentCategory()) {
            case ZPECategories.Emails:
                this.associateEmailWithCase(this.selectedObject());
                break;
            case ZPECategories.ScanPool:
                this.associateScanPoolWithCase(this.selectedObject());
                break;
        }
    };

    private showEmail(accountId: string, mailId: string) {
        this.currentViewer("empty-view");
        this.currentViewerParams({
            accountId: accountId,
            mailId: mailId,
            fullscreen: true
        });
        this.currentViewer("mail-view");
    }

    async deleteMail(accountId: string, mailId: string) {
        let result = await RNSAPI.deleteMailbyId(accountId, mailId);
        if (result.Type === "DeleteSuccessful") {
            this.currentViewer("empty-view");
            this.loadMailData();
        } else {
            alert("Error deleteMail");
        }
    }

    private showScanPoolEntry(fileName: string) {
        this.currentViewer("empty-view");
        this.currentViewerParams({
            fileName: fileName
        });
        this.currentViewer("pdfjs-view");
    }

    showEmails = () => {
        this.currentCategory(ZPECategories.Emails);
    };

    showScanPool = () => {
        this.currentCategory(ZPECategories.ScanPool);
    };

    showEConsult = () => {
        this.currentCategory(ZPECategories.EConsult);
    };

    showDebris = () => {
        this.currentCategory(ZPECategories.Debris);
    };

    constructor() {
        this.loadZPEData();
        this.interval.subscribe(newInterval => this.loadZPEData());
    }
}

let html = fs.readFileSync(__dirname + '/zpe.html', 'utf8');

ko.components.register("zpe-view", {
    viewModel: ZPEViewModel,
    template: html
});